import { API_URL } from "../config";

export async function registerCamera(
  name: string,
  rtsp: string,
  width: number,
  height: number,
  zone_x1: number,
  zone_x2: number,
  zone_y1: number,
  zone_y2: number,
  token: string
) {
  console.log("Registrando câmera:", { name, rtsp, width, height, zone_x1, zone_x2, zone_y1, zone_y2 });

  const response = await fetch(`${API_URL}/cameras`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({ name, rtsp, width, height, zone_x1, zone_x2, zone_y1, zone_y2 }),
  });
  if (!response.ok) {
    throw new Error("Erro ao cadastrar câmera");
  }

  return response.json();
}

export async function deleteCamera(cameraId: string, token: string) {
  const response = await fetch(`${API_URL}/cameras/${cameraId}`, {
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Erro ao deletar câmera");
  }
}

export async function listCameras(token: string) {
  const response = await fetch(`${API_URL}/cameras`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Erro ao buscar câmeras");
  }
  return response.json();
}

export async function listStreams(token: string) {
  const response = await fetch(`${API_URL}/streams`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Erro ao buscar streamings");
  }
  return response.json();
}

export async function listMovements(streamId: string, token: string) {
  const response = await fetch(`${API_URL}/movements/${streamId}`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Erro ao buscar entradas/saídas");
  }
  return response.json();
}

export async function getPeopleCountHistoryRedis(streamId: string, token: string) {
  const response = await fetch(`${API_URL}/people_count_history/redis/${streamId}`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Erro ao buscar histórico de pessoas");
  }
  return response.json();
}

const formatDateForAPI = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Versão original - com data específica
export async function getPeopleCountHistoryCosmos(streamId: string, date: string, token: string) {
  const response = await fetch(`${API_URL}/people_count_history/cosmos/${streamId}?date=${date}`,
    {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  if (!response.ok) {
    throw new Error("Erro ao buscar histórico de pessoas (Cosmos)");
  }
  return response.json();
}

// Nova versão - usa data atual automaticamente
export async function getPeopleCountHistoryCosmosToday(streamId: string, token: string) {
  const todayFormatted = formatDateForAPI(new Date());
  return getPeopleCountHistoryCosmos(streamId, todayFormatted, token);
}

// Função combinada - une Redis + Cosmos automaticamente
export async function getPeopleCountHistoryCombined(streamId: string, token: string) {
  try {
    // Buscar dados em paralelo
    const [redisData, cosmosData] = await Promise.all([
      getPeopleCountHistoryRedis(streamId, token),
      getPeopleCountHistoryCosmosToday(streamId, token)
    ]);

    // Agora ambos têm: { time: "HH:MM:SS", count: number }
    // Unir e ordenar por tempo (string)
    const combined = [...cosmosData, ...redisData]
      .sort((a, b) => {
        // Comparar strings de tempo: "12:02:04" vs "16:52:21"
        return a.time.localeCompare(b.time);
      })
      .filter((item, index, arr) => {
        // Remove duplicatas baseado no time exato
        if (index === 0) return true;
        return item.time !== arr[index - 1].time;
      });

    return combined;
  } catch (error) {
    console.error('Erro ao buscar dados combinados:', error);
    // Fallback: tentar apenas Redis
    try {
      return await getPeopleCountHistoryRedis(streamId, token);
    } catch {
      return [];
    }
  }
}